module.exports = __webpack_public_path__ + "static/media/tipsLayer.6963444c.png";